// Application Insights
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { createBrowserHistory } from 'history';

export const appInsightsReactPlugin = new ReactPlugin();

export const loadAppInsights = () => {
  if (
    (process.env.NEXT_PUBLIC_ENVIRONMENT === 'Production' ||
      process.env.NEXT_PUBLIC_ENVIRONMENT === 'Production-EU') &&
    process.env.NEXT_PUBLIC_APPLICATION_INSIGHTS_INSTRUMENTATION_KEY !== ''
  ) {
    const browserHistory = createBrowserHistory();

    const appInsights = new ApplicationInsights({
      config: {
        connectionString:
          process.env.NEXT_PUBLIC_APPLICATION_INSIGHTS_INSTRUMENTATION_KEY,
        extensions: [appInsightsReactPlugin],
        enableAutoRouteTracking: true,
        extensionConfig: {
          [appInsightsReactPlugin.identifier]: { history: browserHistory },
        },
      },
    });

    appInsights.loadAppInsights();
  }
};
